import en from './en.json';
import es from './es.json';

export type Locale = 'en' | 'es';

export const locales = {
  en,
  es,
};

export const availableLocales = [
  { code: 'en' as Locale, name: 'English', flag: '🇺🇸' },
  { code: 'es' as Locale, name: 'Español', flag: '🇪🇸' },
];

export const defaultLocale: Locale = 'en';

export const getMessages = (locale: Locale) => {
  return locales[locale] || locales[defaultLocale];
};
